/** track via google analytics 4 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function track(
    event_name: string,
    data: any,
    debug: boolean = false,
    event: string = "generic_ga4_event"
) {
    const trackingData = {
        ...data,
        event_name,
        event,
    };
    if (debug) {
        console.log("tracking", trackingData);
    }
    if ((window as any).ITdataLayer) {
        (window as any).ITdataLayer.push(trackingData);
    }
}
